// extracted by mini-css-extract-plugin
module.exports =  {"reviews-section":"GSUceov","reviewsSection":"GSUceov"};